var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { top: "" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function(ref) {
              var _obj, _obj$1

              var on = ref.on
              return [
                _c(
                  "div",
                  _vm._g(
                    {
                      staticClass:
                        "professional-avatar rounded-circular full-center",
                      class:
                        ((_obj = {}),
                        (_obj["elevation-" + _vm.elevation] = !!_vm.elevation),
                        (_obj["mouse-hover"] = _vm.showHoverEffect),
                        _obj),
                      style: {
                        width: _vm.size,
                        height: _vm.size,
                        "min-width": _vm.size,
                        "min-height": _vm.size,
                        "background-color": _vm.color,
                        outline: _vm.border
                          ? "1px solid var(--" + _vm.border + ")"
                          : "",
                        transition: "all 0.5s ease",
                        width: "fit-content",
                        position: "relative"
                      }
                    },
                    on
                  ),
                  [
                    _vm.computedAvatarUrl
                      ? _c("img", {
                          staticClass: "professional-avatar__img",
                          attrs: {
                            src: _vm.computedAvatarUrl,
                            alt: _vm.initials
                          }
                        })
                      : !_vm.hasDefaultSlot
                      ? _c(
                          "label",
                          {
                            class:
                              ((_obj$1 = {
                                "mouse-hover": _vm.showHoverEffect
                              }),
                              (_obj$1[_vm.textClass] = true),
                              _obj$1),
                            style: {
                              "font-size": _vm.textSize,
                              "white-space": "nowrap",
                              width: "max-content",
                              color: _vm.textColor
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.initials) + " ")]
                        )
                      : _vm._e(),
                    _vm._t("default"),
                    _vm.viewProfessional
                      ? _c(
                          "v-icon",
                          {
                            staticClass: "icon",
                            staticStyle: {
                              position: "absolute",
                              right: "0",
                              bottom: "0",
                              "background-color": "gray",
                              "border-radius": "50%",
                              padding: "2px"
                            },
                            attrs: { color: "white", size: _vm.sizeIcon },
                            on: {
                              click: function($event) {
                                return _vm.openProfessional(_vm.professional)
                              }
                            }
                          },
                          [_vm._v(" mdi-eye ")]
                        )
                      : _vm._e()
                  ],
                  2
                )
              ]
            }
          }
        ],
        null,
        true
      )
    },
    [
      _c(
        "span",
        [
          !_vm.hasSlotTooltip
            ? [
                _vm._v(" " + _vm._s(_vm.name) + " "),
                _vm.tooltipSuffix
                  ? [_vm._v(" | " + _vm._s(_vm.tooltipSuffix) + " ")]
                  : _vm._e()
              ]
            : _vm._e(),
          _vm.hasSlotTooltip ? [_vm._t("tooltip")] : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }